import * as ActionType from "../../actions/actionType";

const initialState = {
  data: {},
  isLogin: false,
  isLoginChecked: false,
  token: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionType.RECEIVE_AUTH:
      return {
        ...state,
        data: action.data
      };
    case ActionType.IS_LOGIN:
      return {
        ...state,
        isLogin: action.isLogin
      };
    case ActionType.IS_LOGIN_CHECKED:
      return {
        ...state,
        isLoginChecked: action.isLoginChecked
      };
    case ActionType.SET_AUTH_TOKEN:
      return {
        ...state,
        token: action.token
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/page/auth.js